import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .DetailColumn {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const Line = styled.div`
  display: grid;
  grid-template-columns: 1fr 296px;
  width: 100%;
  column-gap: 24px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  &.priorityWrapper {
    width: 294px;
  }
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #474d66;

  &.optional {
    color: #8f95b2;
  }
`;

export const Input = styled.input`
  display: flex;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 10px 12px 10px 16px;
  height: 42px;
  width: 100%;
  margin-top: 8px;

  font-size: 14px;
  font-weight: 400;

  ::placeholder {
    color: #8f95b2;
  }
`;

interface IDivider {
  height?: string;
}

export const Divider = styled.div<IDivider>`
  height: ${({ height }) => height};
`;

export const TextArea = styled.textarea`
  display: flex;
  flex: 1;
  width: 100%;
  min-height: 276px;
  max-height: 276px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 10px 12px 10px 16px;
  font-size: 14px;
  font-weight: 400;
  color: #474d66;
  resize: none;

  ::placeholder {
    color: #8f95b2;
  }
`;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 8px;
`;

export const AssignButton = styled.div`
  display: flex;
  justify-content: space-between;
  width: 296px;
  height: 42px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  color: #8f95b2;
  font-size: 14px;
  font-weight: 400;
  margin-top: 8px;

  cursor: pointer;
`;

export const IconWrapper = styled.div`
  padding-top: 3px;
`;

export const AddButton = styled.button`
  display: flex;
  height: 42px;
  padding: 10px 16px;
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  color: #c1c4d6;
  gap: 10px;
  align-items: center;
  margin-top: 8px;
  cursor: not-allowed;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const DisabledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FlagContainer = styled.div`
  height: 20px;
`;

export const FlagLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #474d66;

  &.new {
    margin-left: 24px;
  }
`;
